import AuthService from "../login/auth.service";
import { transferencias } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class TransferenciasService {

    async getMotivosTransferencia() {

        var config = {
            method: "get",
            url: transferencias + "transferencia/motivo-transferencia",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken()
            },
        };

        return await axios(config);
    }

    async consultaCantidadTransferencias(){
        let config = {
            method : 'get',
            url: transferencias + "transferencia/exceso/cobro-transf-interb",
            headers : {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken()
            }
        }
        return await axios(config);
    }

}
export default new TransferenciasService();
